import { useT } from "../i18n";
import { useTheme, type ThemePreference } from "../theme";
import { Segmented } from "./Segmented";

/** Light / Dark / System switch backed by `applyTheme`. */
export function ThemeToggle({ className, size = "sm" }: { className?: string; size?: "sm" | "md" | "touch" }) {
  const t = useT();
  const { preference, setPreference } = useTheme();
  return (
    <Segmented<ThemePreference> ariaLabel={t("ui.theme")} className={className} size={size} variant="pill" value={preference} onChange={setPreference}
      options={[{ value: "light", label: t("ui.theme.light") }, { value: "dark", label: t("ui.theme.dark") }, { value: "system", label: t("ui.theme.system") }]} />
  );
}
